import dayjs from "dayjs";

import { Text } from "../../Components/atoms/Typography/Text/Text";
import { ActionButton } from "../../Components/molecules/ActionButton/ActionButton";

export const getColumns = (t, clickHandler) => {
  let columndata = [
    {
      fieldtext: t("common:table-field.userid"),
      field: "userIdentifier",
      width: "180",
      textAlign: "Left",
      key: 0,
    },
    {
      fieldtext: t("common:table-field.name"),
      field: "fullName",
      width: "180",
      textAlign: "Left",
      key: 1,
      template: (props) => {
        return `${props.firstName} ${props.lastName}`;
      },
    },
    {
      fieldtext: t("common:table-field.email"),
      field: "email",
      minWidth: "280px",
      width: "280px",
      textAlign: "Left",
      key: 2,
    },
    {
      fieldtext: t("common:form.mobileNoFirstOnly"),
      field: "phoneNumber",
      width: "180",
      textAlign: "Left",
      key: 3,
      template: (props) => {
        const formattedNumber = props?.phoneNumber?.replace(
          /(\d{2})(\d{4})(\d{4})/,
          "$1 $2 $3",
        );

        const num = props?.phoneNumberDialCode && formattedNumber ? `${props?.phoneNumberDialCode} ${formattedNumber}` : "-"
        return num
      },
    },
    {
      fieldtext: t("common:table-field.role"),
      field: "DisplayName",
      width: "180",
      textAlign: "Left",
      key: 3,
      template: (props) => t(`user.${props.roleName}`, { ns: "glossary" }),
    },
    {
      fieldtext: t("common:table-field.created-date"),
      field: "createdOn",
      width: "180",
      textAlign: "Left",
      key: 4,
      template: (props) => {
        const date = dayjs(props.createdOn).format("DD/MM/YYYY");
        return `${date}`;
      },
      enableGroupByFormat: true,
    },

    {
      fieldtext: t("common:table-field.actions"),
      field: "actions",
      width: "88px",
      textAlign: "Left",
      allowSorting: false,
      headerTextAlign: "Left",
      key: 6,
      template: (props) => {
        return (
          <ActionButton
            clickHandler={(e) => clickHandler(e, props)}
            Options={[
              {
                id: 1,
                element: (
                  <Text
                    text={t("glossary:user.action.edit")}
                    color={"blue.primaryBlue"}
                  />
                ),
              },
              {
                id: 2,
                isShow: !props.hasUserSetPassword,
                element: (
                  <Text
                    text={t("glossary:user.action.reset-password")}
                    color={"blue.primaryBlue"}
                  />
                ),
              },
              {
                id: 3,
                isShow: props.isActive && props.baseUserStatus,
                element: (
                  <Text
                    text={t("glossary:user.action.inactivate-account")}
                    color={"blue.primaryBlue"}
                  />
                ),
              },
              {
                id: 4,
                isShow: !props.isActive && !props.baseUserStatus,
                element: (
                  <Text
                    text={t("glossary:user.action.activate-account")}
                    color={"blue.primaryBlue"}
                  />
                ),
              },
              {
                id: 5,
                element: (
                  <Text
                    text={t("glossary:auth.reset-otp-count.reset-otp-count")}
                    color={"blue.primaryBlue"}
                  />
                ),
              },
            ]}
          />
        );
      },
    },
  ];

  return columndata;
};
